import React, { useState } from "react";
import styled from "styled-components";
import { Layout } from "./ui/Layout";
import { mediaQuery } from "react-styled-mediaquery";
import { Title } from "./ui/Title";
import { Paragraph } from "./ui/Paragraph";
import { Col, Row } from "react-styled-flexboxgrid";
import { colors } from "../lib/constant";
import { IconCheck10, IconQuestion20 } from "../icons-ts";
import { fontFamily, fontSize, product_sans } from "../lib/fonts";
import { Button } from "./ui/Button";
import { TooltipIconBox } from "./ui/TooltipIconBox";
import { ModalRequests } from "./ui/ModalRequests";
import { FormattedMessage } from "react-intl";
export interface TablePriceType {
  key: string;
  title: string;
  dossier: string;
  prixDossier: string;
  prixMois: string;
}

const LayoutCustom = styled(Layout)`
  padding-bottom: 100px;
  border-bottom: 1px solid ${colors.greyLt};

  ${mediaQuery("<=", "tablet")`
    padding-bottom: 50px;
  `}
`;

const SectionPriceTitle = styled.div`
  text-align: center;
  width: 70%;
  margin: 0 auto 80px auto;

  ${mediaQuery("<=", "tablet")`
    width: 100%;
    margin-bottom: 30px;
  `}
`;

const Item = styled.div`
  display: flex;
  align-items: center;

  &:not(:first-child) {
    margin-top: 25px;
  }
`;

const Icon = styled(IconCheck10)`
  margin-right: 15px;
`;

const Label = styled.div`
  color: ${colors.greyDrk};
  ${fontSize("15px")};
  line-height: 18px;
  ${fontFamily(product_sans.regular)}
  display: flex;
  align-items: center;
`;

const Card = styled.div`
  background: #ffffff;
  box-shadow: 0 5px 30px 0 rgba(27, 22, 51, 0.05);
  border-radius: 15px;
  padding: 60px;

  ${mediaQuery("<=", "tablet")`
    padding: 30px;
    margin-top: 50px;
    text-align: center;
  `}
`;

const Price = styled.div`
  color: ${colors.greyDrk};
  ${fontSize("48px")};
  line-height: 40px;
  ${fontFamily(product_sans.bold)}

  > span {
    top: -18px;
    left: -10px;
    position: relative;
    ${fontSize("20px")};
  }
`;

const Month = styled.div`
  color: ${colors.greyDrk};
  ${fontSize("15px")};
  line-height: 18px;
  ${fontFamily(product_sans.regular)}
  margin-top: 5px;
  margin-bottom: 30px;
`;

const Setup = styled.div`
  color: #565b73;
  ${fontSize("13px")};
  line-height: 15px;
  ${fontFamily(product_sans.bold)}
  margin-bottom: 5px;
`;

const Desc = styled.div`
  color: #565b73;
  ${fontSize("13px")};
  line-height: 20px;
  ${fontFamily(product_sans.regular)}
  margin-bottom: 30px;
`;

const TitlePrice = styled.div`
  ${fontSize("18px")};
  line-height: 22px;
  ${fontFamily(product_sans.bold)}
  margin-bottom: 30px;

  ${mediaQuery("<=", "tablet")`
    margin-top: 20px;
    text-align: center;
  `}
`;

export const SectionPrice = () => {
  const [isModalRequestVisible, setIsModalRequestVisible] = useState(false);

  return (
    <>
      <ModalRequests
        isOpen={isModalRequestVisible}
        onRequestClose={() => setIsModalRequestVisible(false)}
      />
      <LayoutCustom id="price">
        <SectionPriceTitle>
          <Title htmlLevel={2} theme="titleBodyStyle">
            <FormattedMessage
              id="sectionPrice.title"
              defaultMessage="Simple & transparent pricing"
            />
          </Title>
          <Paragraph>
            <FormattedMessage
              id="sectionPrice.text"
              defaultMessage="Wether you go for the standard version or the whitelabel version, Flashix has an easy pricing model. One single fee for the platform for small businesses and volume based fee if your expectations are rocket high."
            />
          </Paragraph>
        </SectionPriceTitle>

        <Row middle="xs">
          <Col xs={12} sm={7} md={7} lg={7}>
            <Row>
              <Col xs={12}>
                <TitlePrice>
                  <FormattedMessage
                    id="sectionPrice.all_inclusive"
                    defaultMessage="All inclusive"
                  />
                </TitlePrice>
              </Col>
            </Row>
            <Row>
              <Col xs={6} sm={6} md={6} lg={6}>
                <Item>
                  <div>
                    <Icon width="10" fill={colors.green} />
                  </div>
                  <Label>
                    <FormattedMessage
                      id="sectionPrice.item.licence_free"
                      defaultMessage="Licence fee"
                    />
                  </Label>
                </Item>
                <Item>
                  <div>
                    <Icon width="10" fill={colors.green} />
                  </div>
                  <Label>
                    <FormattedMessage
                      id="sectionPrice.item.encrypted_exchange_data"
                      defaultMessage="Encrypted exchange of data"
                    />
                  </Label>
                </Item>
                <Item>
                  <div>
                    <Icon width="10" fill={colors.green} />
                  </div>
                  <Label>
                    <FormattedMessage
                      id="sectionPrice.item.unlimited_devices_downloads"
                      defaultMessage="Unlimited devices/downloads"
                    />
                  </Label>
                </Item>
                <Item>
                  <div>
                    <Icon width="10" fill={colors.green} />
                  </div>
                  <Label>
                    <FormattedMessage
                      id="sectionPrice.item.unlimited_users_partners"
                      defaultMessage="Unlimited users/partners"
                    />
                  </Label>
                </Item>
              </Col>
              <Col xs={6} sm={6} md={6} lg={6}>
                <Item>
                  <div>
                    <Icon width="10" fill={colors.green} />
                  </div>
                  <Label>
                    <FormattedMessage
                      id="sectionPrice.item.OS"
                      defaultMessage="Android & iOS"
                    />
                  </Label>
                </Item>
                <Item>
                  <div>
                    <Icon width="10" fill={colors.green} />
                  </div>
                  <Label>
                    <FormattedMessage
                      id="sectionPrice.item.technical_maintenance"
                      defaultMessage="Technical maintenance"
                    />
                  </Label>
                </Item>
                <Item>
                  <div>
                    <Icon width="10" fill={colors.green} />
                  </div>
                  <Label>
                    <FormattedMessage
                      id="sectionPrice.item.assistance"
                      defaultMessage="Assistance"
                    />
                  </Label>
                </Item>
                <Item>
                  <div>
                    <Icon width="10" fill={colors.green} />
                  </div>
                  <Label>
                    <div style={{ marginRight: 10 }}>
                      <FormattedMessage
                        id="sectionPrice.item.requests_month"
                        defaultMessage="10.000 requests/month"
                      />
                    </div>
                    <TooltipIconBox
                      onClick={() => setIsModalRequestVisible(true)}
                    >
                      <IconQuestion20 fill="#fff" width="7" height="10" />
                    </TooltipIconBox>
                  </Label>
                </Item>
              </Col>
            </Row>
          </Col>
          <Col xs={12} sm={5} md={5} lg={5}>
            <Card>
              <Price>
                499 <span>€</span>
              </Price>
              <Month>
                <FormattedMessage
                  id="unit.per_month"
                  defaultMessage="per month"
                />
              </Month>
              <Setup>
                <FormattedMessage
                  id="sectionPrice.infos.setup_price"
                  defaultMessage="Initial setup fee {x} € - Renewal setup fee {y} €"
                  values={{
                    x: 2500,
                    y: 650,
                  }}
                />
              </Setup>
              <Desc>
                <FormattedMessage
                  id="sectionPrice.infos.setup_price.desc"
                  defaultMessage="If you want to customize the app to your branding, Flashix has also a whitelabel pricing model available upon request."
                />
              </Desc>
              <a href="mailto:info@igloo.be">
                <Button>
                  <FormattedMessage
                    id="button.label.contactUs"
                    defaultMessage="Contact us"
                  />
                </Button>
              </a>
            </Card>
          </Col>
        </Row>
      </LayoutCustom>
    </>
  );
};
